import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/layouts/base.js";
import SevereNeuytropenia from "@components/severe-neutropenia";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <SevereNeuytropenia mdxType="SevereNeuytropenia" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      